import { css, tokens, media } from '@sail/ui';
import { helmTokens } from './../../theme';
export const styles = {
    rowLayout: [
        css({
            display: 'grid',
            grid: 'auto / minmax(0, 1fr)',
            alignItems: 'start'
        }),
        css.global({
            '[data-stretch-last-item] > *:last-child': {
                marginTop: 'auto'
            }
        })
    ]
};
export const variants = {
    gap: {
        xsmall: css({
            gapY: 'space.200'
        }),
        small: css({
            gapY: 'space.300'
        }),
        normal: css({
            gapY: 'space.400'
        }),
        medium: css({
            gapY: 'space.400',
            [media.up(tokens.viewport.medium)]: {
                gapY: 'space.600'
            }
        }),
        large: css({
            gapY: 'space.400',
            [media.up(tokens.viewport.medium)]: {
                gapY: 'space.600'
            },
            [media.up(tokens.viewport.xlarge)]: {
                gapY: helmTokens.space[1200]
            }
        }),
        xlarge: css({
            gapY: 'space.400',
            [media.up(tokens.viewport.medium)]: {
                gapY: 'space.600'
            },
            [media.up(tokens.viewport.xlarge)]: {
                gapY: helmTokens.space[1200]
            }
        }),
        xxlarge: css({
            gapY: 'space.400',
            [media.up(tokens.viewport.medium)]: {
                gapY: 'space.800'
            },
            [media.up(tokens.viewport.xlarge)]: {
                gapY: helmTokens.space[1600]
            }
        })
    }
};

//# sourceMappingURL=RowLayoutStyles.js.map